import { Badge } from '@mantine/core';
import {
  SESSION_REPAIR_STATUS_COLORS,
  SESSION_REPAIR_STATUS_LABELS,
} from '../constants';
import type { SessionRepairStatus } from '../types';

type SessionRepairStatusBadgeProps = {
  status: SessionRepairStatus;
  duplicateCount?: number;
  gapCount?: number;
};

export function SessionRepairStatusBadge({
  status,
  duplicateCount,
  gapCount,
}: SessionRepairStatusBadgeProps) {
  let label = SESSION_REPAIR_STATUS_LABELS[status];

  if (status === 'needs_repair' && (duplicateCount || gapCount)) {
    const parts = [
      duplicateCount ? `${duplicateCount} duplicati` : null,
      gapCount ? `${gapCount} gap` : null,
    ].filter(Boolean);
    if (parts.length > 0) {
      label = `${label} (${parts.join(', ')})`;
    }
  }

  return (
    <Badge
      color={SESSION_REPAIR_STATUS_COLORS[status]}
      variant={status === 'needs_repair' ? 'outline' : 'light'}
    >
      {label}
    </Badge>
  );
}
